import React from "react";
import './Whatsnewstyle.css';

export default function Whatsnew()
{
    return(
        <section className="secnew" id="Whatsnew">
        <header><marquee><img src="./juggle.gif" /></marquee></header>
        <div className="content">
          <div className="imgBox">
            <img src="./milkshake.gif" />
          </div>
          <div className="textBox">
            <h2>MILKSHAKES<br /><span>Sharing happiness and best taste all over India.</span></h2>
            <p>Our newly added beverage Milkshakes comes with a variety of combinations like - Milk and fruits or Milk and Ice-creams which makes them the most iconic desserts. We don't add extra sugar in our milkshakes, all the sweetness comes from the fruits. We hope that you like the taste of our new drink.</p> 
        </div>
        </div>
      </section>
    );
}